import React from 'react';
// import LogoWhite from '../../assets/icons/logo-white.png';
// import LogoWhite from '../../assets/images/new-logo.webp';

const PerformanceCheckReportHeader = ({ mini = false }) => {
  return (
    <header className={`paper_header ${mini ? 'mini' : ''}`}>
      <p>한국자동차휠수리복원협회</p>
    </header>
  );
};

export default PerformanceCheckReportHeader;
